import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import Moment from "moment";
import { Component, default as React } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Select from 'react-select';


const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class CategoryList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            categories: [],
            categoriesFiltered: [],
            selectedGroup: null,
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            dataSetPrimaryKey: "category_id"
        };

        
    }
    

    async componentDidMount() {
        console.log("In CategoryList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        
        try {
            const categories = await this.getCategories();
            this.setState({ categories: categories, categoriesFiltered: categories });
        } catch (e) {
            alert(e);
        }
        document.title = "Categories lookup";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ categories: [] });        
    }


    
    async getCategories() {
        console.log("Inside getCategories() ");
        
        return API.get("colin", "/slmcategories");
      
    }

    

    addRecord = async event => {
        let categories = [...this.state.categories];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        categories.unshift({
            
            code: "",
            name: "",
            description: "",
            group_id: null,
            group: null,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({categories});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/slmcategories/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/slmcategories/${record["category_id"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

 
        //Check street name not blank
        if (record.group_id === null) {
            return [false,"You must select a group. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let categories = [...this.state.categories];

        var indexOfRecord = categories.findIndex(i => i.category_id === cellInfo.original.category_id);
        console.log("Index = "+ indexOfRecord);
        categories[indexOfRecord][cellInfo.column.id] = event.target.value;
        categories[indexOfRecord].modified = true;
        this.setState({categories});
        let categoriesFiltered = [...this.state.categoriesFiltered];
        categoriesFiltered[cellInfo.index][cellInfo.column.id] = event.target.value;
        this.setState({categoriesFiltered});

    };
    handleNumberChange = (cellInfo, event) => {
        let categories = [...this.state.categories];

        let val = event.target.value.replace(/[^0-9.]/g, "");
        var indexOfRecord = categories.findIndex(i => i.category_id === cellInfo.original.category_id);
        categories[indexOfRecord][cellInfo.column.id] = Number(val);
        categories[indexOfRecord].modified = true;
        this.setState({categories});
        let categoriesFiltered = [...this.state.categoriesFiltered];
        categoriesFiltered[cellInfo.index][cellInfo.column.id] = event.target.value;
        this.setState({categoriesFiltered});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let categories = [...this.state.categories];

        var indexOfRecord = categories.findIndex(i => i.category_id === cellInfo.original.category_id);
        categories[indexOfRecord][cellInfo.column.id] = event.target.checked;
        categories[indexOfRecord].modified = true;
        this.setState({categories});
        let categoriesFiltered = [...this.state.categoriesFiltered];
        categoriesFiltered[cellInfo.index][cellInfo.column.id] = event.target.value;
        this.setState({categoriesFiltered});
    };

    handleDateChange = (cellInfo, event) => {
        let categories = [...this.state.categories];
        var indexOfRecord = categories.findIndex(i => i.category_id === cellInfo.original.category_id);
        categories[indexOfRecord][cellInfo.column.id] = new Date(event);
        categories[indexOfRecord].modified = true;
        this.setState({categories});
        let categoriesFiltered = [...this.state.categoriesFiltered];
        categoriesFiltered[cellInfo.index][cellInfo.column.id] = event.target.value;
        this.setState({categoriesFiltered});
    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let categories = [...this.state.categories];
        for (var i=0; i<categories.length; i++){
            if (categories[i].hasOwnProperty("modified")) {
                if (categories[i].modified === true) {
            const validation = this.validateRecord(categories[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                
                    
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (categories[i].hasOwnProperty("new_record")) {
                                if (categories[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(categories[i]);
                            if (result.result) {
                                categories[i].modified = false;
                                if (categories[i].hasOwnProperty("new_record")) {
                                    if (categories[i].new_record === true) {

                                        categories[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    categories[i].new_record = false;
                                    
                                }
                                else{
                                    const categories = await this.getCategories();
                                    this.setState({ categories });
                                }
                                
                                                               
                            }
                            else {
                                categories[i].issue_date = null;
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    

                
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }
        }
        }   
        if (categories[0].hasOwnProperty("sort_order")) {
            categories.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({categories});

    }

    handleDropDownChange = (cellInfo, event) => {
        let categories = [...this.state.categories];
        var indexOfRecord = categories.findIndex(i => i.category_id === cellInfo.original.category_id);
        categories[indexOfRecord][cellInfo.column.id] = event.value;
        categories[indexOfRecord].group_name = event.label;
        categories[indexOfRecord].modified = true;
        this.setState({categories}); 
        let categoriesFiltered = [...this.state.categoriesFiltered];
        categoriesFiltered[indexOfRecord][cellInfo.column.id] = event.value;
        categoriesFiltered[indexOfRecord].group_name = event.label;
        this.setState({categoriesFiltered});      

    }

    renderEditable = cellInfo => {
        const cellValue = this.state.categoriesFiltered[cellInfo.index][cellInfo.column.id];
        // if(1==2){ //temporarily removing editing
        if (cellInfo.column.id === "group_id") {
            if (cellValue) {
                return (<div>
                    <Select
                    value={{ value: cellValue, label: cellInfo.original.group_name }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.categoryGroups}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select
                    value={{ value: null, label: null }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.categoryGroups}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}        
                                />
                            );
                        }
        }
    // }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [
            
            {
                id: 'category_id',
                Header: 'ID',
                maxWidth: 65,
                accessor: 'category_id' 
                

        }
        , {
                id: 'code',
                Header: 'Code',            
                accessor: 'code',
                maxWidth: 250,
                // Cell: this.renderEditable
                

            }, {
                id: 'name',
                Header: 'Name',            
                accessor: 'name',
                maxWidth: 250,
                // Cell: this.renderEditable

            }
            , {
                id: 'description',
                Header: 'Description',            
                accessor: 'description',
                maxWidth: 250,
                // Cell: this.renderEditable

            }           
           ,
            {
                id: 'group_id',
                Header: 'Group',
                maxWidth: 250,
                accessor: 'group_id',
                // Cell: this.renderEditable
            }
            // ,{
            //     Header: '',
            //     accessor: 'category_id',
            //     maxWidth: 65,
            //     Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            // }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={50}
                    sortable={false}
                />
            )
        }
    }

    handleGroupChange = (selectedGroup) => {
        if(selectedGroup){
        let categories = [...this.state.categories];
        let categoriesFiltered = categories.filter((a)=>{if(a.group_id===selectedGroup.value){return true;}else{return false;}});
        this.setState({categoriesFiltered, selectedGroup});
        }
        else{
            let categories = [...this.state.categories];
            let categoriesFiltered = categories;
            this.setState({categoriesFiltered, selectedGroup},() => this.renderTable(categoriesFiltered));

        }
    }
    renderComponent() {
        return (
            <div className="categories">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                    <Col className="text-left" >
                        <Select
                            value={this.state.selectedCategoryGroup}
                            onChange={this.handleGroupChange}
                            options={this.props.categoryGroups}
                            isClearable                
                        />
                    </Col>
                    <Col className="text-right" >                            
                            {/* <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button> */}
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>

                        {!this.state.isLoading ? this.renderTable(this.state.categoriesFiltered) : this.renderTable(this.state.categoriesFiltered)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="CategoryList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
